import React from 'react';
import './login.scss';
import {useCurrentUser} from '../../contexts/CurrentUserProvider';

function LinkedAccountFailLockedOut() {
  const currentUser = useCurrentUser();

  if (currentUser?.isAuthenticated && currentUser?.logout) {
    currentUser.logout();
    return null;
  }

  return (
    <div className="login logout">
      <h1 className="login__title login__title--margin-top">Account locked</h1>
      <div className="login__line">To protect your account, we've logged you out and blocked access to your online dashboard. This is due to three unsuccessful attempts to verify your identity while updating your linked account online.</div>
      <div className="login__line">For next steps and to unlock your dashboard, please speak to us on live chat.</div>
  </div>
  )
};

export default LinkedAccountFailLockedOut;
